export function getFirstOrDefault<T>(items: Iterable<T>): T | null {
  for (const item of items) {
    if (item) {
      return item;
    }
  }
  return null;
}
